/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast, no-nested-ternary */
import { Button, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import PieChart from '@components/home/assignedContent/progressPie/pieChart';
import styles from './labBanner.module.scss';

const LabBanner: FC<LabBannerProps> = (props: LabBannerProps) => {
    const { uuid, displayName, description, coins, completionRate, duration, potentialScore } = props;

    return (
        <div>
            <div className={styles['lab-banner']}>
                <a
                    id={`lab-banner-${displayName}`}
                    data-testid="lab-banner"
                    className={styles['lab-banner']}
                    href={`/app/lab/${uuid}`}
                >
                    <div className={styles['inner-wrapper']}>
                        <div className={styles.tag}>
                            {translate(
                                completionRate && completionRate === 100
                                    ? 'StartAgain'
                                    : completionRate && completionRate > 0
                                    ? 'Resume'
                                    : 'StartNow'
                            )}
                        </div>
                        <div className={styles['svg-background']}></div>
                        <div className={styles['left-side']}>
                            <div className={styles['top-wrapper']}>
                                <Icon name={'vulnerabilityFix'} className={styles['top-icon']} />
                                <div className={styles.text}>{translate('VULNERABILITY-FIX')}</div>
                            </div>
                            <div className={styles['name-wrapper']}>
                                <div className={styles.name} title={translate(displayName)}>
                                    {translate(displayName)}
                                </div>
                            </div>
                            <div className={styles.description} title={translate(description)}>
                                {translate(description)}
                            </div>
                            <div>
                                <div className={styles['button-wrapper']}>
                                    <a href={`/app/lab/${uuid}`}>
                                        <Button type={'bigGradient'} text={translate('FixNow')} lowerCase />
                                    </a>
                                    {completionRate !== 0 && completionRate && (
                                        <div className={styles['completion-rate-wrapper']}>
                                            <PieChart percentage={Math.trunc(completionRate)} position="relative" />
                                            {coins !== 0 && coins && <hr />}
                                        </div>
                                    )}
                                    <div className={styles['score-wrapper']}>
                                        {coins !== 0 && coins && (
                                            <div className={styles['earned-points']}>
                                                {translate('Earned')}
                                                <Icon name="devCoin" />
                                                <div className={styles.score}>{coins}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr className={styles.divider} />
                        <div className={styles['right-wrapper']}>
                            {potentialScore && (
                                <>
                                    <span className={styles.text}>{`${translate('UpTo')}`}</span>
                                    <div className={styles.coins}>
                                        <Icon name="devCoin" className={styles.coin} />
                                        <div className={styles.points}>{potentialScore?.toLocaleString()}</div>
                                    </div>
                                    <hr className={styles.line} />
                                </>
                            )}
                            {duration && (
                                <div className={styles.duration}>
                                    <Icon name="timeWhite" className={styles['time-icon']} />
                                    <span className={styles.text}>{`${duration}Min`}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default LabBanner;

export interface LabBannerProps {
    uuid: string;
    displayName?: string;
    description?: string;
    coins?: number;
    completionRate?: number;
    duration: string;
    potentialScore?: number;
}
